import { Routes, Route, Navigate } from "react-router-dom";

import Card from "react-bootstrap/Card";

import { PageLink, PageTitle } from "@/../_metronic/layout/core";
import { ReportCard } from "@/components/HospitalizationPermits/ReportCard";
import { Historic } from "@/components/HospitalizationPermits/Historic";

export function HospitalizationPermitsInformation() {
	const informationBreadCrumbs: PageLink = {
		title: "Gerenciamento de AIH",
		path: `/gerenciamento-aih`,
		isActive: false,
		isSeparator: false,
	};

	return (
		<>
			<Routes>
				<Route
					path="boletim/:id"
					element={
						<Card>
							<Card.Body>
								<PageTitle breadcrumbs={[informationBreadCrumbs]}>
									Boletim de AIH
								</PageTitle>
								<ReportCard />
							</Card.Body>
						</Card>
					}
				/>

				<Route
					path="historico/:id"
					element={
						<Card>
							<Card.Body>
								<PageTitle breadcrumbs={[informationBreadCrumbs]}>
									Histórico de AIH
								</PageTitle>
								<Historic />
							</Card.Body>
						</Card>
					}
				/>

				<Route path="*" element={<Navigate to="/error/404" />} />
			</Routes>
		</>
	);
}
